import { dissoc, assoc } from "ramda";

import {
  // REQUEST_ACCOUNT_WALLET,
  SUCCESS_ACCOUNT_WALLET,
  // FAILURE_ACCOUNT_WALLET,
  // updateBenefits,
  ADD_TO_CART_SUCCESS,
} from "actions/cartActions";

// import { riskmedicalLoadSuccess } from "actions/riskmedicalActions";
import { checkoutLoadSuccess } from "actions/checkoutActions";

const initialState = {
  allowOverpurchase: {
    enable: true,
    limit: -1,
  },
  accountDeduction: {
    benefits: "",
    wellness: "",
  },
  itemTypes: [
    {
      id: "benefits",
      title: "Risk & Medical",
    },
    {
      id: "wellness",
      title: "Health & Wellness",
    },
  ],
  accounts: {},
  benefitItems: {
    byId: {},
    all: [],
  },
  wellnessItems: {
    byId: {},
    all: [],
  },
};

// const getSelectedPlan = plans => {
//   const selectedPlan = plans.find(plan => plan.isSelected);
//   const { planId, price, relativePrice, type = "EE", options } = selectedPlan;
//   if (!options) {
//     return { planId, type, price: Number.parseFloat(price) };
//   }
//
//   const selectedOption = options.find(option => option.isSelected);
//   if (!selectedOption) {
//     return { planId, type, price: Number.parseFloat(relativePrice) };
//   }
//
//   const {
//     planId: optionPlanId,
//     type: optionType,
//     relativePrice: optionPrice,
//   } = selectedOption;
//   return {
//     planId: optionPlanId,
//     type: optionType,
//     price: Number.parseFloat(optionPrice),
//   };
// };

export default (state = initialState, action = {}) => {
  switch (action.type) {
    // case FAILURE_ACCOUNT_WALLET: {
    //
    // }

    // case updateBenefits: {
    //   const { benefitList } = action.payload;

    //   const benefitItems = benefitList.reduce((obj, item) => {
    //     const { benefitId: id, plans } = item;
    //     const { planId, type: coverMemberType, price } = getSelectedPlan(plans);
    //     obj[id] = {
    //       id,
    //       total: {
    //         id: planId,
    //         coverMemberType,
    //         price: {
    //           numericValue: price
    //         }
    //       }
    //     };
    //     return obj;
    //   }, {});

    //   return {
    //     ...state,
    //     benefitItems: {
    //       ...state.benefitItems,
    //       byId: benefitItems,
    //     }
    //   };
    // }

    // case riskmedicalLoadSuccess: {
    //   const { summary } = action.payload;
    //   const { enrolmentDeductionFrom, wellnessPurchaseFrom } = summary;
    //   const availableAmount = parseFloat(summary && summary.availablePoints ? summary.availablePoints.numericValue : "0.00");

    //   return {
    //     ...state,
    //     accountDeduction: {
    //       benefits: enrolmentDeductionFrom,
    //       wellness: wellnessPurchaseFrom,
    //     },
    //   };
    // }

    case checkoutLoadSuccess: {
      const {
        accountDeduction,
        panels: {
          benefitsEnrolment: {
            benefits: { items: benefitItems },
          },
          eCommerce: {
            wellness: { items: wellnessItems },
          },
          paymentSummary: { allowOverpuchase: allowOverpurchase },
        },
      } = action.payload;

      return {
        ...state,
        accountDeduction,
        allowOverpurchase,
        benefitItems,
        wellnessItems,
      };
    }

    case SUCCESS_ACCOUNT_WALLET: {
      const { accountDtos } = action.payload;
      const accounts = accountDtos.reduce((acc, item) => {
        acc[item.accountType] = item;
        return acc;
      }, {});

      return {
        ...state,
        accounts,
      };
    }

    case ADD_TO_CART_SUCCESS: {
      const { productId: id, productName: name, productPrice: unitPrice, quantity } = action.meta;

      const item = {
        id,
        name,
        unitPrice,
        quantity,
      };

      const itemsById = state.wellnessItems.byId;
      const allItems = state.wellnessItems.all;

      const newAllItems =
        (quantity > 0 && (itemsById[id] ? allItems : [].concat(allItems, id))) ||
        allItems.filter(x => x !== id);

      const newItemsById = quantity > 0 ? assoc(id, item, itemsById) : dissoc(id, itemsById);

      return {
        ...state,
        wellnessItems: {
          byId: newItemsById,
          all: newAllItems,
        },
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/cartReducer.jsx